import { render, staticRenderFns } from "./IconXhnk.vue?vue&type=template&id=c6d1eb0c"
import script from "./IconXhnk.vue?vue&type=script&lang=js"
export * from "./IconXhnk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports